module.exports = __webpack_public_path__ + "static/media/icon_evaluation_win.15e04dff.svg";